import { render, staticRenderFns } from "./IndicatorCard.vue?vue&type=template&id=20f342b2&scoped=true"
import script from "./IndicatorCard.vue?vue&type=script&lang=js"
export * from "./IndicatorCard.vue?vue&type=script&lang=js"
import style0 from "./IndicatorCard.vue?vue&type=style&index=0&id=20f342b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f342b2",
  null
  
)

export default component.exports